<template>
  <div class="honor">
    <div class="h-main">
      <div class="iso">
        <h1>ISO</h1>
        <el-row :gutter="20" v-if="isMobile">
          <el-col :span="8">
            <img src="../assets/北京沃慕科技有限公司 ISO_00.png" alt="">
          </el-col>
          <el-col :span="8">
            <img src="../assets/北京沃慕科技有限公司 ISO_01.png" alt="">
          </el-col>
          <el-col :span="8">
            <img src="../assets/北京沃慕科技有限公司 ISO_02.png" alt="">
          </el-col>
        </el-row>
        <div v-else class="iso2">
        </div>
      </div>
      <div class="invent">
        <h1 v-if="isEnglish">Invention patent</h1>
        <h1 v-else>发明专利</h1>
        <el-row :gutter="20" v-if="isMobile">
          <el-col :span="12">
            <img src="../assets/基于人工智能的节能减碳智慧供热系统及方法_00.png" alt="">
          </el-col>
          <el-col :span="12">
            <img src="../assets/一种用于温室供暖的太阳能蓄热供暖装置_00.png" alt="">
          </el-col>
        </el-row>
        <div v-else class="zhuanlifaming">
        </div>
      </div>
      <div class="ruan">
        <h1 v-if="isEnglish">Soft copyright</h1>
        <h1 v-else>软著</h1>
        <div class="outer"  v-if="isMobile">
          <div class="ruanzhu">
            <img src="../assets/ruan1.png" alt="">
          </div>
          <div class="ruanzhu">
            <img src="../assets/ruan2.png" alt="">
          </div>
          <div class="ruanzhu">
            <img src="../assets/ruan3.png" alt="">
          </div>
          <div class="ruanzhu">
            <img src="../assets/ruan4.png" alt="">
          </div>
          <div class="ruanzhu">
            <img src="../assets/ruan5.png" alt="">
          </div>
          <div class="ruanzhu">
            <img src="../assets/ruan6.png" alt="">
          </div>
          <div class="ruanzhu">
            <img src="../assets/ruan7.png" alt="">
          </div>
          <div class="ruanzhu">
            <img src="../assets/ruan8.png" alt="">
          </div>
          <div class="ruanzhu">
            <img src="../assets/ruan9.png" alt="">
          </div>
        </div>
        <div v-else class="ruanzhu">
        </div>
      </div>
      <div class="famous" v-if="!isMobile">
        <h1 v-if="isEnglish">Trademark</h1>
        <h1 v-else>商标</h1>
        <!-- <div class="outer">
            <div class="shangbiao">
              <img src="../assets/womu1.png" alt="">
            </div>
            <div class="shangbiao">
              <img src="../assets/womu2.png" alt="">
            </div>
            <div class="shangbiao">
              <img src="../assets/womu3.png" alt="">
            </div>
            
            <div class="shangbiao">
              <img src="../assets/womu4.png" alt="">
            </div>
            
            <div class="shangbiao">
              <img src="../assets/womu5.png" alt="">
            </div>
            <div class="shangbiao">
              <img src="../assets/womu6.png" alt="">
            </div>
            <div class="shangbiao">
              <img src="../assets/womu7.png" alt="">
            </div>
            <div class="shangbiao">
              <img src="../assets/e48b88378fb905f10191201ede443638_00.png" alt="">
            </div>
            <div class="shangbiao">
              <img src="../assets/womu8.png" alt="">
            </div>
            
            <div class="shangbiao">
              <img src="../assets/womu9.png" alt="">
            </div>
            <div class="shangbiao">
              <img src="../assets/womu10.png" alt="">
            </div>
            <div class="shangbiao">
              <img src="../assets/womu11.png" alt="">
            </div>
            <div class="shangbiao">
              <img src="../assets/womu12.png" alt="">
            </div>
            <div class="shangbiao">
              <img src="../assets/womu13.png" alt="">
            </div>
            <div class="shangbiao">
              <img src="../assets/womu14.png" alt="">
            </div>
        </div>
        <div class="outer">
            <div class="shangbiao">
              <img src="../assets/womut1.png" alt="">
            </div>
            <div class="shangbiao">
              <img src="../assets/womut2.png" alt="">
            </div>
            <div class="shangbiao">
              <img src="../assets/womut3.png" alt="">
            </div>
            
            <div class="shangbiao">
              <img src="../assets/womut4.png" alt="">
            </div>
            
            <div class="shangbiao">
              <img src="../assets/1.png" alt="">
            </div>
            <div class="shangbiao">
              <img src="../assets/2.png" alt="">
            </div>
            <div class="shangbiao">
              <img src="../assets/3.png" alt="">
            </div>
            <div class="shangbiao">
              <img src="../assets/image.png" alt="">
            </div>
            <div class="shangbiao">
              <img src="../assets/4.png" alt="">
            </div>
            <div class="shangbiao">
              <img src="../assets/5.png" alt="">
            </div>
            <div class="shangbiao">
              <img src="../assets/6.png" alt="">
            </div>
            <div class="shangbiao">
              <img src="../assets/7.png" alt="">
            </div>
            <div class="shangbiao">
              <img src="../assets/womut5.png" alt="">
            </div>
            <div class="shangbiao">
              <img src="../assets/womut6.png" alt="">
            </div>
            <div class="shangbiao">
              <img src="../assets/womut7.png" alt="">
            </div>
        </div> -->
        <div class="outer2">

        </div>
      </div>
    </div>

  </div>

</template>

<script setup name="HonorBook">
import { onMounted, ref, onUnmounted, computed } from 'vue'
onMounted(() => {
  checkmobile();
  window.addEventListener('resize', checkmobile);
})
onUnmounted(() => {
  window.removeEventListener('resize', checkmobile);
})
const isEnglish = computed(() => {
  return window.location.pathname.startsWith('/en')
})

const isMobile = ref(false);
const checkmobile = () => {
  if (window.screen.width <= 1024) {
    isMobile.value = true;
  } else {
    isMobile.value = false;
  }
}
</script>

<style scoped>
.honor {
  width: 80%;
  margin: 4em auto;
}

.h-main {
  width: 100%;
  margin: 0 auto;
}

.iso {
  width: 100%;
  height: 100%;
  margin: 2em auto;
}

.iso .iso2 {
  margin-left: 20%;
  width: 60%;
  height: 20em;
  /* margin: 20em auto; */
  background-image: url("./../assets/iso.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.iso>h1,
.invent>h1 {
  width: 80%;
  margin: 0 auto;
  text-align: center;
  margin-bottom: 1em;
}

.iso .el-row {
  width: 50em;
  margin: 0 auto !important;
}

.iso .el-row .el-col {
  width: 100%;
  height: 20em;
}

.iso .el-row .el-col img {
  width: 100%;
  height: 100%;
}

.invent {
  width: 100%;
  height: 100%;
  margin: 2em auto;
}

.invent .zhuanlifaming {
  width: 40%;
  margin-left: 30%;
  height: 20em;
  background-image: url("./../assets/zhuanlifaming.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.invent .el-row {
  width: 35em;
  margin: 0 auto !important;
}

.invent .el-row .el-col {
  height: 20em;
}

.invent .el-row .el-col img {
  width: 100%;
  height: 100%;
  border: 1px solid #ddd;
}

.famous,
.ruan {
  width: 100%;
  height: 100%;
  margin: 2em auto;
}

.ruan .ruanzhu {
  height: 14em;
  background-image: url("./../assets/ruanzhu.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  margin: 2em auto;
}

.famous h1,
.ruan h1 {
  width: 100%;
  margin: 0 auto;
  text-align: center;
}

.famous .outer2 {
  width: 100%;
  height: 36em;
  overflow: hidden;
  margin: 2em auto;
  display: flex;
  justify-content: space-between;
  background-color: #f79090;
  background-image: url("./../assets/outer2.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.famous .outer,
.ruan .outer {
  width: 100%;
  height: 18em;
  overflow: hidden;
  margin: 2em auto;
  display: flex;
  justify-content: space-between;
}

.famous .outer .shangbiao img,
.ruan .outer .ruanzhu img {
  position: relative;
  width: 10em;
  height: 15em;
  margin-top: -1em;
  margin-left: -9em;
}

.famous .outer .shangbiao1 img {
  position: relative;
  width: 10em;
  height: 15em;
  margin-top: -1em;
  margin-left: -2.5em;
}

.famous .outer .image img,
.famous .outer .image1 img {
  position: relative;
  width: 10em;
  height: 15em;
  margin-top: -1em;
}

.ruan .outer .ruanzhu img {
  margin-top: 0;
}

.famous .outer .shangbiao:nth-child(1) img {
  margin-left: 0;
  z-index: 1;
}

.famous .outer .shangbiao:nth-child(2) img {
  z-index: 2;
}

.famous .outer .shangbiao:nth-child(3) img {
  z-index: 3;
}

.famous .outer .shangbiao:nth-child(4) img {
  z-index: 4;
}

.famous .outer .shangbiao:nth-child(5) img {
  z-index: 5;
}

.famous .outer .shangbiao:nth-child(6) img {
  z-index: 6;
}

.famous .outer .shangbiao:nth-child(7) img {
  z-index: 7;
}

.famous .outer .shangbiao:nth-child(8) img {
  z-index: 8;
}

.famous .outer .shangbiao:nth-child(9) img {
  z-index: 7;
}

.famous .outer .shangbiao:nth-child(10) img {
  z-index: 6;
}

.famous .outer .shangbiao:nth-child(11) img {
  z-index: 5;
}

.famous .outer .shangbiao:nth-child(12) img {
  z-index: 4;
}

.famous .outer .shangbiao:nth-child(13) img {
  z-index: 3;
}

.famous .outer .shangbiao:nth-child(14) img {
  z-index: 2;
}

.famous .outer .shangbiao:nth-child(15) img {
  z-index: 1;
}

.ruan .outer .ruanzhu:nth-child(9) img {
  z-index: 1;
}

.ruan .outer .ruanzhu:nth-child(1) img {
  margin-left: 0;
  z-index: 1;
}

.ruan .outer .ruanzhu:nth-child(2) img {
  z-index: 2;
}

.ruan .outer .ruanzhu:nth-child(3) img {
  z-index: 3;
}

.ruan .outer .ruanzhu:nth-child(4) img {
  z-index: 4;
}

.ruan .outer .ruanzhu:nth-child(5) img {
  z-index: 5;
}

.ruan .outer .ruanzhu:nth-child(6) img {
  z-index: 4;
}

.ruan .outer .ruanzhu:nth-child(7) img {
  z-index: 3;
}

.ruan .outer .ruanzhu:nth-child(8) img {
  z-index: 2;
}

.ruan .outer .ruanzhu:nth-child(9) img {
  z-index: 1;
}

.famous .outer .shangbiao1:nth-child(1) img {
  margin-left: 0;
  z-index: 1;
}

.famous .outer .shangbiao1:nth-child(2) img {
  z-index: 2;
}

.famous .outer .shangbiao1:nth-child(3) img {
  z-index: 3;
}

.famous .outer .shangbiao1:nth-child(4) img {
  z-index: 4;
}

.famous .outer .shangbiao1:nth-child(5) img {
  z-index: 6;
}

.famous .outer .shangbiao1:nth-child(6) img {
  z-index: 5;
}

.famous .outer .shangbiao1:nth-child(7) img {
  z-index: 4;
}

.famous .outer .shangbiao1:nth-child(8) img {
  z-index: 3;
}

.famous .outer .shangbiao1:nth-child(9) img {
  z-index: 2;
}

.famous .outer .shangbiao1:nth-child(10) img {
  z-index: 1;
}

.famous .outer .image:nth-child(1) img {
  z-index: 1;
}

.famous .outer .image:nth-child(2) img {
  z-index: 2;
}

.famous .outer .image:nth-child(3) img {
  z-index: 3;
}

.famous .outer .image:nth-child(4) img {
  z-index: 4;
}

.famous .outer .image:nth-child(5) img {
  z-index: 3;
}

.famous .outer .image:nth-child(6) img {
  z-index: 2;
}

.famous .outer .image:nth-child(7) img {
  z-index: 1;
}

@media (max-width: 1024px) {
  .honor {
    width: 100%;
    margin: 2em auto;
  }

  .iso .el-row {
    width: 22em;
    margin: 0 auto !important;
  }

  .iso>h1,
  .invent>h1 {
    width: 80%;
    margin: 0 auto;
    text-align: center;
    margin-bottom: 1em;
    font-size: 1.2em;
  }

  .iso .el-row .el-col {
    width: 100%;
    height: 8em;
  }

  .invent .el-row {
    width: 14em;
    margin: 0 auto !important;
  }

  .invent .el-row .el-col {
    height: 8em;
  }

  .ruan {
    width: 18em;
  }

  .ruan h1 {
    font-size: 1.2em;
  }

  .ruan .outer {
    height: 10em;
  }

  .ruan .outer .ruanzhu img {
    width: 5em;
    height: 8em;
    margin-left: -5em;
  }
}
</style>